import ApplicationController from "./application_controller";
// import Rails from "@rails/ujs";
// import React from 'react'
// import ReactDOM from 'react-dom'; 
// import FilesExplorer from '../components/FilesExplorer/FilesExplorer'

export default class extends ApplicationController {

  static targets = ["hm0_output"];

  connect() {
    console.log("File Explorer en cours ...");
    super.connect();

  }

  filter_by_type(event){
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#filter_by_type", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }

  filter_by_table(event){
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#filter_by_table", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }

  filter_by_search(event){
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#filter_by_search", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }

  afterFilterByTable(element) {
    document.querySelectorAll(".sidebar_card").forEach(card => {
      card.removeAttribute("style");
    });

    element.style.backgroundColor = "#b7e7fd";

    document.getElementById("files_explorer_search").value = "";
    jQuery('.child-loader').hide();
  }

  afterFilterBySearch(element) {
    jQuery('.child-loader').hide();
  }

  afterFilterByType(element) {
    jQuery('.child-loader').hide();
  }


  trier_by_intitule(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_intitule", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_nom_fichier(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_nom_fichier", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_cree_le(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_cree_le", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_cree_par(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_cree_par", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_modifie_le(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_modifie_le", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_modifie_par(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_modifie_par", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_type(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_type", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_associe_a(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_associe_a", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }
  trier_by_taille(element) {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate("FilesExplorers#trier_by_taille", event.currentTarget);
    } else {
      console.log("STOP NOT CONNECTED");
      jQuery('.child-loader').hide();
    }
  }

}
